/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router'
import { CampaignAnalyticsPage } from '@/features/operations/campaign-analytics'
import { requireRole } from '@/lib/auth-guards'

/** Admin Reports Traffic Explorer is deferred; keep per-campaign analytics until then. */
export const Route = createFileRoute('/_authenticated/campaigns/$id/analytics')({
  component: CampaignAnalyticsRoutePage,
  beforeLoad: requireRole(['admin']),
})

function CampaignAnalyticsRoutePage() {
  const { id } = Route.useParams()
  return <CampaignAnalyticsPage campaignId={id} />
}
